var En = Object.defineProperty;
var xn = (e, t, r) => t in e ? En(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var Ce = (e, t, r) => (xn(e, typeof t != "symbol" ? t + "" : t, r), r);
import X, { createContext as vn, useState as U, useMemo as Ht, useCallback as te, useEffect as ut, useContext as Rn } from "react";
import { useNavigate as Sn, Outlet as Tn, Navigate as On, Link as hr, useLocation as Pn } from "react-router-dom";
import { Logger as W, Roles as re, getStorage as Cn, useToast as _n, setStorage as An, getRouteFrom as je, removeStorage as kn, translateUserRoleInRole as $n, Button as dt, LazyImage as pr } from "@gbs-monorepo-packages/common";
import x, { css as se, createGlobalStyle as Fn } from "styled-components";
var st = { exports: {} }, pe = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Vt;
function Nn() {
  if (Vt)
    return pe;
  Vt = 1;
  var e = X, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function i(u, f, c) {
    var h, g = {}, v = null, y = null;
    c !== void 0 && (v = "" + c), f.key !== void 0 && (v = "" + f.key), f.ref !== void 0 && (y = f.ref);
    for (h in f)
      n.call(f, h) && !a.hasOwnProperty(h) && (g[h] = f[h]);
    if (u && u.defaultProps)
      for (h in f = u.defaultProps, f)
        g[h] === void 0 && (g[h] = f[h]);
    return { $$typeof: t, type: u, key: v, ref: y, props: g, _owner: o.current };
  }
  return pe.Fragment = r, pe.jsx = i, pe.jsxs = i, pe;
}
var me = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wt;
function Ln() {
  return Wt || (Wt = 1, process.env.NODE_ENV !== "production" && function() {
    var e = X, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), u = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), h = Symbol.for("react.suspense_list"), g = Symbol.for("react.memo"), v = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), m = Symbol.iterator, w = "@@iterator";
    function A(s) {
      if (s === null || typeof s != "object")
        return null;
      var d = m && s[m] || s[w];
      return typeof d == "function" ? d : null;
    }
    var $ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function _(s) {
      {
        for (var d = arguments.length, p = new Array(d > 1 ? d - 1 : 0), E = 1; E < d; E++)
          p[E - 1] = arguments[E];
        V("error", s, p);
      }
    }
    function V(s, d, p) {
      {
        var E = $.ReactDebugCurrentFrame, C = E.getStackAddendum();
        C !== "" && (d += "%s", p = p.concat([C]));
        var k = p.map(function(O) {
          return String(O);
        });
        k.unshift("Warning: " + d), Function.prototype.apply.call(console[s], console, k);
      }
    }
    var Q = !1, Ve = !1, j = !1, B = !1, ee = !1, Y;
    Y = Symbol.for("react.module.reference");
    function qr(s) {
      return !!(typeof s == "string" || typeof s == "function" || s === n || s === a || ee || s === o || s === c || s === h || B || s === y || Q || Ve || j || typeof s == "object" && s !== null && (s.$$typeof === v || s.$$typeof === g || s.$$typeof === i || s.$$typeof === u || s.$$typeof === f || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      s.$$typeof === Y || s.getModuleId !== void 0));
    }
    function Jr(s, d, p) {
      var E = s.displayName;
      if (E)
        return E;
      var C = d.displayName || d.name || "";
      return C !== "" ? p + "(" + C + ")" : p;
    }
    function Et(s) {
      return s.displayName || "Context";
    }
    function G(s) {
      if (s == null)
        return null;
      if (typeof s.tag == "number" && _("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof s == "function")
        return s.displayName || s.name || null;
      if (typeof s == "string")
        return s;
      switch (s) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case a:
          return "Profiler";
        case o:
          return "StrictMode";
        case c:
          return "Suspense";
        case h:
          return "SuspenseList";
      }
      if (typeof s == "object")
        switch (s.$$typeof) {
          case u:
            var d = s;
            return Et(d) + ".Consumer";
          case i:
            var p = s;
            return Et(p._context) + ".Provider";
          case f:
            return Jr(s, s.render, "ForwardRef");
          case g:
            var E = s.displayName || null;
            return E !== null ? E : G(s.type) || "Memo";
          case v: {
            var C = s, k = C._payload, O = C._init;
            try {
              return G(O(k));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var ae = Object.assign, fe = 0, xt, vt, Rt, St, Tt, Ot, Pt;
    function Ct() {
    }
    Ct.__reactDisabledLog = !0;
    function Yr() {
      {
        if (fe === 0) {
          xt = console.log, vt = console.info, Rt = console.warn, St = console.error, Tt = console.group, Ot = console.groupCollapsed, Pt = console.groupEnd;
          var s = {
            configurable: !0,
            enumerable: !0,
            value: Ct,
            writable: !0
          };
          Object.defineProperties(console, {
            info: s,
            log: s,
            warn: s,
            error: s,
            group: s,
            groupCollapsed: s,
            groupEnd: s
          });
        }
        fe++;
      }
    }
    function Gr() {
      {
        if (fe--, fe === 0) {
          var s = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: ae({}, s, {
              value: xt
            }),
            info: ae({}, s, {
              value: vt
            }),
            warn: ae({}, s, {
              value: Rt
            }),
            error: ae({}, s, {
              value: St
            }),
            group: ae({}, s, {
              value: Tt
            }),
            groupCollapsed: ae({}, s, {
              value: Ot
            }),
            groupEnd: ae({}, s, {
              value: Pt
            })
          });
        }
        fe < 0 && _("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var We = $.ReactCurrentDispatcher, qe;
    function Re(s, d, p) {
      {
        if (qe === void 0)
          try {
            throw Error();
          } catch (C) {
            var E = C.stack.trim().match(/\n( *(at )?)/);
            qe = E && E[1] || "";
          }
        return `
` + qe + s;
      }
    }
    var Je = !1, Se;
    {
      var Kr = typeof WeakMap == "function" ? WeakMap : Map;
      Se = new Kr();
    }
    function _t(s, d) {
      if (!s || Je)
        return "";
      {
        var p = Se.get(s);
        if (p !== void 0)
          return p;
      }
      var E;
      Je = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var k;
      k = We.current, We.current = null, Yr();
      try {
        if (d) {
          var O = function() {
            throw Error();
          };
          if (Object.defineProperty(O.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(O, []);
            } catch (K) {
              E = K;
            }
            Reflect.construct(s, [], O);
          } else {
            try {
              O.call();
            } catch (K) {
              E = K;
            }
            s.call(O.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (K) {
            E = K;
          }
          s();
        }
      } catch (K) {
        if (K && E && typeof K.stack == "string") {
          for (var T = K.stack.split(`
`), I = E.stack.split(`
`), F = T.length - 1, N = I.length - 1; F >= 1 && N >= 0 && T[F] !== I[N]; )
            N--;
          for (; F >= 1 && N >= 0; F--, N--)
            if (T[F] !== I[N]) {
              if (F !== 1 || N !== 1)
                do
                  if (F--, N--, N < 0 || T[F] !== I[N]) {
                    var M = `
` + T[F].replace(" at new ", " at ");
                    return s.displayName && M.includes("<anonymous>") && (M = M.replace("<anonymous>", s.displayName)), typeof s == "function" && Se.set(s, M), M;
                  }
                while (F >= 1 && N >= 0);
              break;
            }
        }
      } finally {
        Je = !1, We.current = k, Gr(), Error.prepareStackTrace = C;
      }
      var le = s ? s.displayName || s.name : "", Mt = le ? Re(le) : "";
      return typeof s == "function" && Se.set(s, Mt), Mt;
    }
    function Xr(s, d, p) {
      return _t(s, !1);
    }
    function Zr(s) {
      var d = s.prototype;
      return !!(d && d.isReactComponent);
    }
    function Te(s, d, p) {
      if (s == null)
        return "";
      if (typeof s == "function")
        return _t(s, Zr(s));
      if (typeof s == "string")
        return Re(s);
      switch (s) {
        case c:
          return Re("Suspense");
        case h:
          return Re("SuspenseList");
      }
      if (typeof s == "object")
        switch (s.$$typeof) {
          case f:
            return Xr(s.render);
          case g:
            return Te(s.type, d, p);
          case v: {
            var E = s, C = E._payload, k = E._init;
            try {
              return Te(k(C), d, p);
            } catch {
            }
          }
        }
      return "";
    }
    var Oe = Object.prototype.hasOwnProperty, At = {}, kt = $.ReactDebugCurrentFrame;
    function Pe(s) {
      if (s) {
        var d = s._owner, p = Te(s.type, s._source, d ? d.type : null);
        kt.setExtraStackFrame(p);
      } else
        kt.setExtraStackFrame(null);
    }
    function Qr(s, d, p, E, C) {
      {
        var k = Function.call.bind(Oe);
        for (var O in s)
          if (k(s, O)) {
            var T = void 0;
            try {
              if (typeof s[O] != "function") {
                var I = Error((E || "React class") + ": " + p + " type `" + O + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof s[O] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw I.name = "Invariant Violation", I;
              }
              T = s[O](d, O, E, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (F) {
              T = F;
            }
            T && !(T instanceof Error) && (Pe(C), _("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", E || "React class", p, O, typeof T), Pe(null)), T instanceof Error && !(T.message in At) && (At[T.message] = !0, Pe(C), _("Failed %s type: %s", p, T.message), Pe(null));
          }
      }
    }
    var en = Array.isArray;
    function Ye(s) {
      return en(s);
    }
    function tn(s) {
      {
        var d = typeof Symbol == "function" && Symbol.toStringTag, p = d && s[Symbol.toStringTag] || s.constructor.name || "Object";
        return p;
      }
    }
    function rn(s) {
      try {
        return $t(s), !1;
      } catch {
        return !0;
      }
    }
    function $t(s) {
      return "" + s;
    }
    function Ft(s) {
      if (rn(s))
        return _("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", tn(s)), $t(s);
    }
    var he = $.ReactCurrentOwner, nn = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Nt, Lt, Ge;
    Ge = {};
    function on(s) {
      if (Oe.call(s, "ref")) {
        var d = Object.getOwnPropertyDescriptor(s, "ref").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return s.ref !== void 0;
    }
    function sn(s) {
      if (Oe.call(s, "key")) {
        var d = Object.getOwnPropertyDescriptor(s, "key").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return s.key !== void 0;
    }
    function an(s, d) {
      if (typeof s.ref == "string" && he.current && d && he.current.stateNode !== d) {
        var p = G(he.current.type);
        Ge[p] || (_('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', G(he.current.type), s.ref), Ge[p] = !0);
      }
    }
    function ln(s, d) {
      {
        var p = function() {
          Nt || (Nt = !0, _("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        p.isReactWarning = !0, Object.defineProperty(s, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function cn(s, d) {
      {
        var p = function() {
          Lt || (Lt = !0, _("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        p.isReactWarning = !0, Object.defineProperty(s, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var un = function(s, d, p, E, C, k, O) {
      var T = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: s,
        key: d,
        ref: p,
        props: O,
        // Record the component responsible for creating this element.
        _owner: k
      };
      return T._store = {}, Object.defineProperty(T._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(T, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.defineProperty(T, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: C
      }), Object.freeze && (Object.freeze(T.props), Object.freeze(T)), T;
    };
    function dn(s, d, p, E, C) {
      {
        var k, O = {}, T = null, I = null;
        p !== void 0 && (Ft(p), T = "" + p), sn(d) && (Ft(d.key), T = "" + d.key), on(d) && (I = d.ref, an(d, C));
        for (k in d)
          Oe.call(d, k) && !nn.hasOwnProperty(k) && (O[k] = d[k]);
        if (s && s.defaultProps) {
          var F = s.defaultProps;
          for (k in F)
            O[k] === void 0 && (O[k] = F[k]);
        }
        if (T || I) {
          var N = typeof s == "function" ? s.displayName || s.name || "Unknown" : s;
          T && ln(O, N), I && cn(O, N);
        }
        return un(s, T, I, C, E, he.current, O);
      }
    }
    var Ke = $.ReactCurrentOwner, jt = $.ReactDebugCurrentFrame;
    function ie(s) {
      if (s) {
        var d = s._owner, p = Te(s.type, s._source, d ? d.type : null);
        jt.setExtraStackFrame(p);
      } else
        jt.setExtraStackFrame(null);
    }
    var Xe;
    Xe = !1;
    function Ze(s) {
      return typeof s == "object" && s !== null && s.$$typeof === t;
    }
    function Dt() {
      {
        if (Ke.current) {
          var s = G(Ke.current.type);
          if (s)
            return `

Check the render method of \`` + s + "`.";
        }
        return "";
      }
    }
    function fn(s) {
      {
        if (s !== void 0) {
          var d = s.fileName.replace(/^.*[\\\/]/, ""), p = s.lineNumber;
          return `

Check your code at ` + d + ":" + p + ".";
        }
        return "";
      }
    }
    var Bt = {};
    function hn(s) {
      {
        var d = Dt();
        if (!d) {
          var p = typeof s == "string" ? s : s.displayName || s.name;
          p && (d = `

Check the top-level render call using <` + p + ">.");
        }
        return d;
      }
    }
    function It(s, d) {
      {
        if (!s._store || s._store.validated || s.key != null)
          return;
        s._store.validated = !0;
        var p = hn(d);
        if (Bt[p])
          return;
        Bt[p] = !0;
        var E = "";
        s && s._owner && s._owner !== Ke.current && (E = " It was passed a child from " + G(s._owner.type) + "."), ie(s), _('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, E), ie(null);
      }
    }
    function Ut(s, d) {
      {
        if (typeof s != "object")
          return;
        if (Ye(s))
          for (var p = 0; p < s.length; p++) {
            var E = s[p];
            Ze(E) && It(E, d);
          }
        else if (Ze(s))
          s._store && (s._store.validated = !0);
        else if (s) {
          var C = A(s);
          if (typeof C == "function" && C !== s.entries)
            for (var k = C.call(s), O; !(O = k.next()).done; )
              Ze(O.value) && It(O.value, d);
        }
      }
    }
    function pn(s) {
      {
        var d = s.type;
        if (d == null || typeof d == "string")
          return;
        var p;
        if (typeof d == "function")
          p = d.propTypes;
        else if (typeof d == "object" && (d.$$typeof === f || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        d.$$typeof === g))
          p = d.propTypes;
        else
          return;
        if (p) {
          var E = G(d);
          Qr(p, s.props, "prop", E, s);
        } else if (d.PropTypes !== void 0 && !Xe) {
          Xe = !0;
          var C = G(d);
          _("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", C || "Unknown");
        }
        typeof d.getDefaultProps == "function" && !d.getDefaultProps.isReactClassApproved && _("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function mn(s) {
      {
        for (var d = Object.keys(s.props), p = 0; p < d.length; p++) {
          var E = d[p];
          if (E !== "children" && E !== "key") {
            ie(s), _("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", E), ie(null);
            break;
          }
        }
        s.ref !== null && (ie(s), _("Invalid attribute `ref` supplied to `React.Fragment`."), ie(null));
      }
    }
    function zt(s, d, p, E, C, k) {
      {
        var O = qr(s);
        if (!O) {
          var T = "";
          (s === void 0 || typeof s == "object" && s !== null && Object.keys(s).length === 0) && (T += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var I = fn(C);
          I ? T += I : T += Dt();
          var F;
          s === null ? F = "null" : Ye(s) ? F = "array" : s !== void 0 && s.$$typeof === t ? (F = "<" + (G(s.type) || "Unknown") + " />", T = " Did you accidentally export a JSX literal instead of a component?") : F = typeof s, _("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", F, T);
        }
        var N = dn(s, d, p, C, k);
        if (N == null)
          return N;
        if (O) {
          var M = d.children;
          if (M !== void 0)
            if (E)
              if (Ye(M)) {
                for (var le = 0; le < M.length; le++)
                  Ut(M[le], s);
                Object.freeze && Object.freeze(M);
              } else
                _("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ut(M, s);
        }
        return s === n ? mn(N) : pn(N), N;
      }
    }
    function gn(s, d, p) {
      return zt(s, d, p, !0);
    }
    function bn(s, d, p) {
      return zt(s, d, p, !1);
    }
    var yn = bn, wn = gn;
    me.Fragment = n, me.jsx = yn, me.jsxs = wn;
  }()), me;
}
process.env.NODE_ENV === "production" ? st.exports = Nn() : st.exports = Ln();
var ft = st.exports;
const ht = ft.Fragment, R = ft.jsx, D = ft.jsxs, jn = ({
  user: e,
  permissions: t = [],
  roles: r = []
}) => {
  const { permissions: n = [], roles: o = [] } = e;
  return !(t.length && (!n.length || !t.every((i) => n.includes(i))) || r.length && (!o.length || !r.some((i) => o.includes(i))));
}, mr = "gbs-auth-channel";
var ce = /* @__PURE__ */ ((e) => (e.SignOut = "signOut", e.NotifyForbidden = "forbidden", e))(ce || {});
const gr = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?#&~^])[A-Za-z\d@$!%*?#&~^]{8,}$/;
var Ae = /* @__PURE__ */ ((e) => (e.USER = "@gbs-auth/user", e))(Ae || {});
class br {
  constructor(t, r, n) {
    Ce(this, "api");
    Ce(this, "url", {
      forgotPassword: "reset-password",
      resetPassword: "reset-password/change-password",
      refresh: "api/refresh",
      signIn: "api/login",
      signOut: "api/logout",
      unregister: "delete-account",
      getManagers: "api/admin-user/managers"
    });
    Ce(this, "frontendUrl", {
      edgeRoute: "http://localhost:5173",
      adminRoute: "http://localhost:5174",
      clientRoute: "http://localhost:5175"
    });
    this.api = t, r && (this.url = { ...this.url, ...r }), n && (this.frontendUrl = { ...this.frontendUrl, ...n });
  }
  async forgotPassword({ email: t }) {
    const r = await this.api.post(this.url.forgotPassword, { email: t }).then((n) => n.data).catch((n) => {
      W.debug("auth err:", n);
    });
    W.debug("response: ", r);
  }
  async resetPassword({
    email: t,
    password: r
  }) {
    const { data: n } = await this.api.patch(this.url.resetPassword, {
      email: t,
      password: r
    }).then((o) => o.data).catch((o) => {
      throw o;
    });
    return n;
  }
  async refresh() {
    const t = await this.api.get(this.url.refresh).then((r) => (localStorage.setItem("JWT_TOKEN", r.data.token), r.data)).catch((r) => {
      throw r;
    });
    W.debug("response: ", t);
  }
  async signIn({
    email: t,
    password: r
  }) {
    return await this.api.post(this.url.signIn, { email: t, password: r }).then((o) => {
      const a = o.data.data;
      let i = !1, u = "";
      switch (window.location.origin) {
        case this.frontendUrl.adminRoute:
          !a.roles.includes(re.ADMIN) && !a.roles.includes(re.MANAGER) && (i = !0, a.roles.includes(re.STAFF) || a.roles.includes(re.CREW) ? u = this.frontendUrl.clientRoute : u = this.frontendUrl.edgeRoute);
          break;
        case this.frontendUrl.clientRoute:
          !a.roles.includes(re.STAFF) && !a.roles.includes(re.CREW) && (i = !0, a.roles.includes(re.ADMIN) || a.roles.includes(re.MANAGER) ? u = this.frontendUrl.adminRoute : u = this.frontendUrl.edgeRoute);
          break;
      }
      return i ? (u += `/permission-redirect?firstName=${a.firstName}&lastName=${a.lastName}&email=${a.email}&roles=${a.roles.toString()}&companyId=${a.companyId}&id=${a.id}&token=${o.data.token}`, window.location.assign(u), null) : (localStorage.setItem("JWT_TOKEN", o.data.token), a);
    }).catch((o) => {
      throw o;
    });
  }
  async signOut() {
    const t = await this.api.get(this.url.signOut).then((r) => (localStorage.removeItem("JWT_TOKEN"), r.data)).catch((r) => {
      throw r;
    });
    W.debug("response: ", t);
  }
  async unregister({ id: t }) {
    const r = await this.api.delete(`${this.url.unregister}?id=${t}`).then((n) => n.data).catch((n) => {
      W.debug("auth err:", n);
    });
    W.debug("response: ", r);
  }
  async getManagers() {
    return await this.api.get(`${this.url.getManagers}`).then((r) => r.data).catch((r) => {
      throw r;
    });
  }
}
const yr = new BroadcastChannel(mr), Ks = () => {
  yr.postMessage(ce.SignOut);
}, Xs = () => {
  yr.postMessage(ce.NotifyForbidden);
}, Zs = async (e, t) => {
  const r = new br(e, t);
  W.debug("REFRESH TOKEN"), await r.refresh();
};
let Qe = !1;
const _e = /* @__PURE__ */ new Set(), Qs = async (e) => (e.headers.Authorization = `Bearer ${localStorage.getItem("JWT_TOKEN") ?? ""}`, await Promise.resolve(e)), ea = async (e, {
  axiosInstance: t,
  customUrls: r,
  baseURL: n,
  debug: o = !1,
  events: a
}) => {
  var i, u, f, c, h, g, v, y, m, w, A, $, _;
  if (o && W.debug("interceptors ERROR:", [e, (i = e.response) == null ? void 0 : i.status]), ((u = e.config) == null ? void 0 : u.baseURL) === n)
    switch ((f = e.response) == null ? void 0 : f.status) {
      case 401:
        if (((c = e.response.data) == null ? void 0 : c.message) === "Expired JWT Token" || ((g = (h = e.response.data) == null ? void 0 : h.error) == null ? void 0 : g.message) === "Expired JWT Token")
          return await qt(
            e,
            t,
            a,
            r
          );
        a.handlerBroadcastSignOut();
        break;
      case 403:
        if (((v = e.response.data) == null ? void 0 : v.message) === "Forbidden" || ((m = (y = e.response.data) == null ? void 0 : y.error) == null ? void 0 : m.message) === "Forbidden")
          a.handlerNotifyForbidden();
        else if (((A = (w = e.response.data) == null ? void 0 : w.message) == null ? void 0 : A.includes("Access Denied")) ?? ((_ = ($ = e.response.data) == null ? void 0 : $.error) == null ? void 0 : _.message.includes("Access Denied")))
          return await qt(
            e,
            t,
            a,
            r
          );
        break;
    }
  return await Promise.reject(e);
}, qt = async (e, t, r, n) => {
  const o = e.config ?? {}, a = {}, i = new Promise((f, c) => {
    a.onSuccess = () => {
      f(t(o));
    }, a.onFailure = (h) => {
      c(h);
    }, _e.add(a);
  });
  if (!Qe) {
    Qe = !0;
    try {
      await r.handlerRefresh(t, n), _e.forEach((f) => {
        var c;
        (c = f.onSuccess) == null || c.call(f);
      });
    } catch {
      _e.forEach((c) => {
        var h;
        (h = c.onFailure) == null || h.call(c, e);
      }), r.handlerBroadcastSignOut();
    } finally {
      Qe = !1;
    }
  }
  const u = await i;
  return _e.delete(a), u;
}, wr = vn(
  {}
), Jt = new BroadcastChannel(mr), ta = ({
  authorizationRoute: e,
  axiosInstance: t,
  children: r,
  customUrls: n,
  mainContentRoute: o,
  frontendUrls: a = {
    edgeRoute: "http://localhost:5173",
    adminRoute: "http://localhost:5174",
    clientRoute: "http://localhost:5175"
  }
}) => {
  const [i, u] = U(
    Cn(Ae.USER)
  ), f = !!i, c = Sn(), { addToast: h } = _n(), g = Ht(() => (i == null ? void 0 : i.companyId) ?? 0, [i]), v = te(
    (j, B) => {
      u(j), An(Ae.USER, j), B !== !1 && c(je(o), { replace: !0 });
    },
    [o, c]
  ), y = Ht(
    () => new br(t, n, a),
    [t, n, a]
  ), m = te(() => {
    u(null), kn(Ae.USER), c(je(e), { replace: !0 });
  }, [c, e]), w = te(
    async ({ email: j }) => {
      await y.forgotPassword({ email: j }).catch((B) => {
        throw B;
      });
    },
    [y]
  ), A = te(
    async ({ email: j, password: B }) => {
      await y.resetPassword({ email: j, password: B }).catch((ee) => {
        throw ee;
      });
    },
    [y]
  ), $ = te(
    async ({ email: j, password: B }) => {
      const ee = await y.signIn({ email: j, password: B }).catch((Y) => {
        throw Y;
      });
      ee && v(ee);
    },
    [y, v]
  ), _ = te(
    (j) => {
      v(j, !1);
    },
    [v]
  ), V = te(async () => {
    try {
      await y.signOut(), Jt.postMessage(ce.SignOut), m();
    } catch (j) {
      W.debug("err:  ", j);
    }
  }, [y, m]), Q = te(async () => await y.getManagers(), [y]), Ve = (j) => {
    let B = null;
    for (const ee of j.values()) {
      const Y = $n[ee] ?? null;
      Y && (B ? B.level < Y.level && (B = Y) : B = Y);
    }
    return B;
  };
  return ut(() => {
    Jt.onmessage = (j) => {
      switch (j.data) {
        case ce.SignOut:
          m();
          break;
        case ce.NotifyForbidden:
          h({
            title: "Action not allowed",
            description: "Ops, you don't have permission to execute this action.",
            styleType: "error",
            dataCy: "forbidden-error-toast"
          });
          break;
      }
    };
  }, []), /* @__PURE__ */ R(
    wr.Provider,
    {
      value: {
        forgotPassword: w,
        isAuthenticated: f,
        resetPassword: A,
        signIn: $,
        syncUserData: _,
        signOut: V,
        user: i,
        clientIdByUser: g,
        getCurrentRole: Ve,
        saveUser: v,
        getManagers: Q
      },
      children: r
    }
  );
}, Ee = () => Rn(wr), Er = ({ permissions: e, roles: t }, r = null) => {
  const { user: n } = Ee(), o = r ?? n;
  return o ? jn({
    user: o,
    permissions: e,
    roles: t
  }) : null;
}, ra = ({
  alternativeChildren: e,
  children: t,
  forceIgnore: r,
  permissions: n,
  roles: o
}) => {
  const a = Er({ permissions: n, roles: o });
  return /* @__PURE__ */ R(ht, { children: (r ?? !1) || (a ?? !1) ? t : e });
};
var Dn = Object.defineProperty, Yt = Object.getOwnPropertySymbols, Bn = Object.prototype.hasOwnProperty, In = Object.prototype.propertyIsEnumerable, Gt = (e, t, r) => t in e ? Dn(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, et = (e, t) => {
  for (var r in t || (t = {}))
    Bn.call(t, r) && Gt(e, r, t[r]);
  if (Yt)
    for (var r of Yt(t))
      In.call(t, r) && Gt(e, r, t[r]);
  return e;
}, S = {
  black300: "#111213",
  blackTranslucent250: "rgba(0, 0, 0, 0.250)",
  blackTranslucent400: "rgba(0, 0, 0, 0.439)",
  blue50: "#b9d8ea",
  blue100: "#6dc5ea",
  blue200: "#3eb4e4",
  blue250: "#007bad",
  blue275: "#2F80ED",
  blue300: "#145091",
  blue400: "#00426b",
  blue500: "#2f80ed",
  blueTranslucent200: "rgba(62, 180, 228, 0.15)",
  gray100: "#d2dce7",
  gray200: "#c4c4c4",
  gray250: "#8a9099",
  gray300: "#6f7780",
  gray350: "#3f434a",
  gray400: "#414042",
  gray500: "#25282d",
  green150: "#8ec64d",
  green200: "#49c96d",
  green300: "#20a144",
  green400: "#0a8852",
  greenTranslucent200: "rgba(73, 201, 109, 0.15)",
  lightGray50: "#f8f8f8",
  lightGray100: "#ededed",
  lightGray200: "#d9d9d9",
  lightGray300: "#c6c9cc",
  orange400: "#df5a29",
  orange500: "#c44829",
  orange600: "#833421",
  orangeTranslucent400: "rgba(223, 90, 41, 0.15)",
  red200: "#e14d4e",
  red300: "#f00",
  white300: "#fff",
  whiteTranslucent100: "rgba(255, 255, 255, 0.100)",
  yellow200: "#ffdb56"
}, xr = {
  backgroundHoverLight: S.whiteTranslucent100,
  backgroundHover: "#25282d0a",
  background: "#f5f7fa",
  backgroundDarker: S.lightGray50,
  messageBackgroundMe: "#e8ebfa",
  messageBackgroundClient: "#f5f5f5",
  messageBackgroundAdmin: "#d8d8f0"
}, Un = {
  authPagesBackground: xr.background,
  authPagesFieldBorder: "#4aaff9",
  authPagesLink: "#304ffd",
  button: S.blue400,
  buttonShadow: S.blackTranslucent400,
  divider: "rgba(0, 0, 0, 0.1)",
  dropzoneBackground: S.lightGray50,
  dropzoneBorder: S.lightGray300,
  dropzoneBorderError: S.red300,
  dropzoneBorderFocus: S.blue250,
  dropzoneBorderSuccess: S.green200,
  dropzoneText: S.gray350,
  headerText: S.gray350,
  fieldFocus: S.blue250,
  inputBorder: S.gray400,
  inputBorderLight: S.gray200,
  inputPlaceholder: S.gray200,
  labelText: S.gray300,
  sidebarBackground: S.white300,
  sidebarBackgroundActive: S.lightGray50,
  sidebarText: S.gray350,
  sidebarTextLight: S.gray250,
  statusError: S.orangeTranslucent400,
  statusTextError: S.orange500,
  statusInfo: S.blueTranslucent200,
  statusTextInfo: S.blue300,
  statusSuccess: S.greenTranslucent200,
  statusTextSuccess: S.green300,
  statusWarning: S.blueTranslucent200,
  statusTextWarning: S.orange500,
  text: S.gray350,
  textLight: S.gray250,
  toastError: S.orange500,
  toastTextError: S.white300,
  toastInfo: S.blue400,
  toastTextInfo: S.blue400,
  toastSuccess: S.green400,
  toastTextSuccess: S.white300,
  toastWarning: S.orange500,
  toastTextWarning: S.orange500,
  scrollbar: "#6665",
  scrollbarHover: "#9998",
  statusTextComplete: "#13dc28",
  statusTextInProgress: "#DC7413",
  statusTextLow: "#13dc28",
  statusTextMedium: "#F9C400",
  statusTextHigh: "#DC1313"
}, b = et(et(et({}, S), xr), Un);
se`
  position: relative;

  &::after {
    content: '';
    background-color: currentColor;
    bottom: 0;
    height: 1px;
    left: 0;
    position: absolute;
    transform-origin: bottom right;
    transform: scaleX(0);
    transition: transform 0.25s ease-out;
    width: 100%;
  }

  &:hover::after {
    transform-origin: bottom left;
    transform: scaleX(1);
  }
`;
var z = {
  px: "3px",
  xs: "4px",
  sm: "6px",
  md: "8px",
  lg: "14px",
  xl: "20px",
  full: "99999px"
};
se`
  &::-webkit-scrollbar {
    height: 12px;
    width: 12px;
  }
  &::-webkit-scrollbar-corner {
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-clip: padding-box;
    background-color: ${b.scrollbar};
    border: 2px solid transparent;
    border-radius: ${z.lg};
    min-height: 45px;
    &:hover {
      background-color: ${b.scrollbarHover};
    }
  }
  &:not(:hover) {
    &::-webkit-scrollbar {
      visibility: hidden;
    }
  }
`;
var zn = {
  modal: "0 0 8px -2px rgba(0, 0, 0, 0.1), 0 6px 20px -3px rgba(0, 0, 0, 0.2)"
};
Fn`

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html {
    @media (max-width: 1080px) {
      font-size: 93.75%;
    }

    @media (max-width: 720px) {
      font-size: 87.5%;
    }
  }

  body {
    -webkit-font-smoothing: antialiased;
    background-color: ${b.white300};
  }

  body,
  input,
  textarea,
  button {
    color: ${b.text};
    font-family: 'Montserrat', 'Roboto', sans-serif;
    font-weight: 400;
  }

  button {
    cursor: pointer;
  }

  html, body, #root {
    height: 100%;
  }

  [disabled] {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;
const Mn = x.div`
  background-color: ${b.authPagesBackground};
  inset: 0;
  position: fixed;
`, Hn = x.div`
  background-color: ${b.white300};
  border-radius: ${z.lg};
  box-shadow: ${zn.modal};
  left: 50%;
  max-width: 450px;
  padding: 25px;
  position: fixed;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 90vw;

  &:focus {
    outline: none;
  }
`, pt = ({
  children: e,
  dataCy: t = "form-container"
}) => /* @__PURE__ */ D(ht, { children: [
  /* @__PURE__ */ R(Mn, { "data-cy": "overlay" }),
  /* @__PURE__ */ R(Hn, { "data-cy": t, children: e })
] }), na = ({
  children: e,
  loginPath: t,
  permissions: r,
  redirectPath: n,
  roles: o
}) => {
  const a = Er({ permissions: r, roles: o });
  if (a ?? !1)
    return e ?? /* @__PURE__ */ R(Tn, {});
  const i = je(a === null ? t : n);
  return W.debug("redirecting you to ", i), /* @__PURE__ */ R(On, { to: i, replace: !0 });
};
function vr(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: Vn } = Object.prototype, { getPrototypeOf: mt } = Object, Be = ((e) => (t) => {
  const r = Vn.call(t);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), J = (e) => (e = e.toLowerCase(), (t) => Be(t) === e), Ie = (e) => (t) => typeof t === e, { isArray: de } = Array, we = Ie("undefined");
function Wn(e) {
  return e !== null && !we(e) && e.constructor !== null && !we(e.constructor) && H(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Rr = J("ArrayBuffer");
function qn(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Rr(e.buffer), t;
}
const Jn = Ie("string"), H = Ie("function"), Sr = Ie("number"), Ue = (e) => e !== null && typeof e == "object", Yn = (e) => e === !0 || e === !1, ke = (e) => {
  if (Be(e) !== "object")
    return !1;
  const t = mt(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, Gn = J("Date"), Kn = J("File"), Xn = J("Blob"), Zn = J("FileList"), Qn = (e) => Ue(e) && H(e.pipe), eo = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || H(e.append) && ((t = Be(e)) === "formdata" || // detect form-data instance
  t === "object" && H(e.toString) && e.toString() === "[object FormData]"));
}, to = J("URLSearchParams"), ro = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function xe(e, t, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let n, o;
  if (typeof e != "object" && (e = [e]), de(e))
    for (n = 0, o = e.length; n < o; n++)
      t.call(null, e[n], n, e);
  else {
    const a = r ? Object.getOwnPropertyNames(e) : Object.keys(e), i = a.length;
    let u;
    for (n = 0; n < i; n++)
      u = a[n], t.call(null, e[u], u, e);
  }
}
function Tr(e, t) {
  t = t.toLowerCase();
  const r = Object.keys(e);
  let n = r.length, o;
  for (; n-- > 0; )
    if (o = r[n], t === o.toLowerCase())
      return o;
  return null;
}
const Or = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), Pr = (e) => !we(e) && e !== Or;
function at() {
  const { caseless: e } = Pr(this) && this || {}, t = {}, r = (n, o) => {
    const a = e && Tr(t, o) || o;
    ke(t[a]) && ke(n) ? t[a] = at(t[a], n) : ke(n) ? t[a] = at({}, n) : de(n) ? t[a] = n.slice() : t[a] = n;
  };
  for (let n = 0, o = arguments.length; n < o; n++)
    arguments[n] && xe(arguments[n], r);
  return t;
}
const no = (e, t, r, { allOwnKeys: n } = {}) => (xe(t, (o, a) => {
  r && H(o) ? e[a] = vr(o, r) : e[a] = o;
}, { allOwnKeys: n }), e), oo = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), so = (e, t, r, n) => {
  e.prototype = Object.create(t.prototype, n), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), r && Object.assign(e.prototype, r);
}, ao = (e, t, r, n) => {
  let o, a, i;
  const u = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (o = Object.getOwnPropertyNames(e), a = o.length; a-- > 0; )
      i = o[a], (!n || n(i, e, t)) && !u[i] && (t[i] = e[i], u[i] = !0);
    e = r !== !1 && mt(e);
  } while (e && (!r || r(e, t)) && e !== Object.prototype);
  return t;
}, io = (e, t, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= t.length;
  const n = e.indexOf(t, r);
  return n !== -1 && n === r;
}, lo = (e) => {
  if (!e)
    return null;
  if (de(e))
    return e;
  let t = e.length;
  if (!Sr(t))
    return null;
  const r = new Array(t);
  for (; t-- > 0; )
    r[t] = e[t];
  return r;
}, co = ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && mt(Uint8Array)), uo = (e, t) => {
  const n = (e && e[Symbol.iterator]).call(e);
  let o;
  for (; (o = n.next()) && !o.done; ) {
    const a = o.value;
    t.call(e, a[0], a[1]);
  }
}, fo = (e, t) => {
  let r;
  const n = [];
  for (; (r = e.exec(t)) !== null; )
    n.push(r);
  return n;
}, ho = J("HTMLFormElement"), po = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, n, o) {
    return n.toUpperCase() + o;
  }
), Kt = (({ hasOwnProperty: e }) => (t, r) => e.call(t, r))(Object.prototype), mo = J("RegExp"), Cr = (e, t) => {
  const r = Object.getOwnPropertyDescriptors(e), n = {};
  xe(r, (o, a) => {
    t(o, a, e) !== !1 && (n[a] = o);
  }), Object.defineProperties(e, n);
}, go = (e) => {
  Cr(e, (t, r) => {
    if (H(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const n = e[r];
    if (H(n)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, bo = (e, t) => {
  const r = {}, n = (o) => {
    o.forEach((a) => {
      r[a] = !0;
    });
  };
  return de(e) ? n(e) : n(String(e).split(t)), r;
}, yo = () => {
}, wo = (e, t) => (e = +e, Number.isFinite(e) ? e : t), tt = "abcdefghijklmnopqrstuvwxyz", Xt = "0123456789", _r = {
  DIGIT: Xt,
  ALPHA: tt,
  ALPHA_DIGIT: tt + tt.toUpperCase() + Xt
}, Eo = (e = 16, t = _r.ALPHA_DIGIT) => {
  let r = "";
  const { length: n } = t;
  for (; e--; )
    r += t[Math.random() * n | 0];
  return r;
};
function xo(e) {
  return !!(e && H(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const vo = (e) => {
  const t = new Array(10), r = (n, o) => {
    if (Ue(n)) {
      if (t.indexOf(n) >= 0)
        return;
      if (!("toJSON" in n)) {
        t[o] = n;
        const a = de(n) ? [] : {};
        return xe(n, (i, u) => {
          const f = r(i, o + 1);
          !we(f) && (a[u] = f);
        }), t[o] = void 0, a;
      }
    }
    return n;
  };
  return r(e, 0);
}, Ro = J("AsyncFunction"), So = (e) => e && (Ue(e) || H(e)) && H(e.then) && H(e.catch), l = {
  isArray: de,
  isArrayBuffer: Rr,
  isBuffer: Wn,
  isFormData: eo,
  isArrayBufferView: qn,
  isString: Jn,
  isNumber: Sr,
  isBoolean: Yn,
  isObject: Ue,
  isPlainObject: ke,
  isUndefined: we,
  isDate: Gn,
  isFile: Kn,
  isBlob: Xn,
  isRegExp: mo,
  isFunction: H,
  isStream: Qn,
  isURLSearchParams: to,
  isTypedArray: co,
  isFileList: Zn,
  forEach: xe,
  merge: at,
  extend: no,
  trim: ro,
  stripBOM: oo,
  inherits: so,
  toFlatObject: ao,
  kindOf: Be,
  kindOfTest: J,
  endsWith: io,
  toArray: lo,
  forEachEntry: uo,
  matchAll: fo,
  isHTMLForm: ho,
  hasOwnProperty: Kt,
  hasOwnProp: Kt,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Cr,
  freezeMethods: go,
  toObjectSet: bo,
  toCamelCase: po,
  noop: yo,
  toFiniteNumber: wo,
  findKey: Tr,
  global: Or,
  isContextDefined: Pr,
  ALPHABET: _r,
  generateString: Eo,
  isSpecCompliantForm: xo,
  toJSONObject: vo,
  isAsyncFn: Ro,
  isThenable: So
};
function P(e, t, r, n, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), r && (this.config = r), n && (this.request = n), o && (this.response = o);
}
l.inherits(P, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: l.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const Ar = P.prototype, kr = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  kr[e] = { value: e };
});
Object.defineProperties(P, kr);
Object.defineProperty(Ar, "isAxiosError", { value: !0 });
P.from = (e, t, r, n, o, a) => {
  const i = Object.create(Ar);
  return l.toFlatObject(e, i, function(f) {
    return f !== Error.prototype;
  }, (u) => u !== "isAxiosError"), P.call(i, e.message, t, r, n, o), i.cause = e, i.name = e.name, a && Object.assign(i, a), i;
};
const To = null;
function it(e) {
  return l.isPlainObject(e) || l.isArray(e);
}
function $r(e) {
  return l.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Zt(e, t, r) {
  return e ? e.concat(t).map(function(o, a) {
    return o = $r(o), !r && a ? "[" + o + "]" : o;
  }).join(r ? "." : "") : t;
}
function Oo(e) {
  return l.isArray(e) && !e.some(it);
}
const Po = l.toFlatObject(l, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function ze(e, t, r) {
  if (!l.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), r = l.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(w, A) {
    return !l.isUndefined(A[w]);
  });
  const n = r.metaTokens, o = r.visitor || h, a = r.dots, i = r.indexes, f = (r.Blob || typeof Blob < "u" && Blob) && l.isSpecCompliantForm(t);
  if (!l.isFunction(o))
    throw new TypeError("visitor must be a function");
  function c(m) {
    if (m === null)
      return "";
    if (l.isDate(m))
      return m.toISOString();
    if (!f && l.isBlob(m))
      throw new P("Blob is not supported. Use a Buffer instead.");
    return l.isArrayBuffer(m) || l.isTypedArray(m) ? f && typeof Blob == "function" ? new Blob([m]) : Buffer.from(m) : m;
  }
  function h(m, w, A) {
    let $ = m;
    if (m && !A && typeof m == "object") {
      if (l.endsWith(w, "{}"))
        w = n ? w : w.slice(0, -2), m = JSON.stringify(m);
      else if (l.isArray(m) && Oo(m) || (l.isFileList(m) || l.endsWith(w, "[]")) && ($ = l.toArray(m)))
        return w = $r(w), $.forEach(function(V, Q) {
          !(l.isUndefined(V) || V === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            i === !0 ? Zt([w], Q, a) : i === null ? w : w + "[]",
            c(V)
          );
        }), !1;
    }
    return it(m) ? !0 : (t.append(Zt(A, w, a), c(m)), !1);
  }
  const g = [], v = Object.assign(Po, {
    defaultVisitor: h,
    convertValue: c,
    isVisitable: it
  });
  function y(m, w) {
    if (!l.isUndefined(m)) {
      if (g.indexOf(m) !== -1)
        throw Error("Circular reference detected in " + w.join("."));
      g.push(m), l.forEach(m, function($, _) {
        (!(l.isUndefined($) || $ === null) && o.call(
          t,
          $,
          l.isString(_) ? _.trim() : _,
          w,
          v
        )) === !0 && y($, w ? w.concat(_) : [_]);
      }), g.pop();
    }
  }
  if (!l.isObject(e))
    throw new TypeError("data must be an object");
  return y(e), t;
}
function Qt(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(n) {
    return t[n];
  });
}
function gt(e, t) {
  this._pairs = [], e && ze(e, this, t);
}
const Fr = gt.prototype;
Fr.append = function(t, r) {
  this._pairs.push([t, r]);
};
Fr.toString = function(t) {
  const r = t ? function(n) {
    return t.call(this, n, Qt);
  } : Qt;
  return this._pairs.map(function(o) {
    return r(o[0]) + "=" + r(o[1]);
  }, "").join("&");
};
function Co(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Nr(e, t, r) {
  if (!t)
    return e;
  const n = r && r.encode || Co, o = r && r.serialize;
  let a;
  if (o ? a = o(t, r) : a = l.isURLSearchParams(t) ? t.toString() : new gt(t, r).toString(n), a) {
    const i = e.indexOf("#");
    i !== -1 && (e = e.slice(0, i)), e += (e.indexOf("?") === -1 ? "?" : "&") + a;
  }
  return e;
}
class _o {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, r, n) {
    return this.handlers.push({
      fulfilled: t,
      rejected: r,
      synchronous: n ? n.synchronous : !1,
      runWhen: n ? n.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    l.forEach(this.handlers, function(n) {
      n !== null && t(n);
    });
  }
}
const er = _o, Lr = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, Ao = typeof URLSearchParams < "u" ? URLSearchParams : gt, ko = typeof FormData < "u" ? FormData : null, $o = typeof Blob < "u" ? Blob : null, Fo = (() => {
  let e;
  return typeof navigator < "u" && ((e = navigator.product) === "ReactNative" || e === "NativeScript" || e === "NS") ? !1 : typeof window < "u" && typeof document < "u";
})(), No = (() => typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), q = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Ao,
    FormData: ko,
    Blob: $o
  },
  isStandardBrowserEnv: Fo,
  isStandardBrowserWebWorkerEnv: No,
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
function Lo(e, t) {
  return ze(e, new q.classes.URLSearchParams(), Object.assign({
    visitor: function(r, n, o, a) {
      return q.isNode && l.isBuffer(r) ? (this.append(n, r.toString("base64")), !1) : a.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function jo(e) {
  return l.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function Do(e) {
  const t = {}, r = Object.keys(e);
  let n;
  const o = r.length;
  let a;
  for (n = 0; n < o; n++)
    a = r[n], t[a] = e[a];
  return t;
}
function jr(e) {
  function t(r, n, o, a) {
    let i = r[a++];
    const u = Number.isFinite(+i), f = a >= r.length;
    return i = !i && l.isArray(o) ? o.length : i, f ? (l.hasOwnProp(o, i) ? o[i] = [o[i], n] : o[i] = n, !u) : ((!o[i] || !l.isObject(o[i])) && (o[i] = []), t(r, n, o[i], a) && l.isArray(o[i]) && (o[i] = Do(o[i])), !u);
  }
  if (l.isFormData(e) && l.isFunction(e.entries)) {
    const r = {};
    return l.forEachEntry(e, (n, o) => {
      t(jo(n), o, r, 0);
    }), r;
  }
  return null;
}
const Bo = {
  "Content-Type": void 0
};
function Io(e, t, r) {
  if (l.isString(e))
    try {
      return (t || JSON.parse)(e), l.trim(e);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (r || JSON.stringify)(e);
}
const Me = {
  transitional: Lr,
  adapter: ["xhr", "http"],
  transformRequest: [function(t, r) {
    const n = r.getContentType() || "", o = n.indexOf("application/json") > -1, a = l.isObject(t);
    if (a && l.isHTMLForm(t) && (t = new FormData(t)), l.isFormData(t))
      return o && o ? JSON.stringify(jr(t)) : t;
    if (l.isArrayBuffer(t) || l.isBuffer(t) || l.isStream(t) || l.isFile(t) || l.isBlob(t))
      return t;
    if (l.isArrayBufferView(t))
      return t.buffer;
    if (l.isURLSearchParams(t))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let u;
    if (a) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return Lo(t, this.formSerializer).toString();
      if ((u = l.isFileList(t)) || n.indexOf("multipart/form-data") > -1) {
        const f = this.env && this.env.FormData;
        return ze(
          u ? { "files[]": t } : t,
          f && new f(),
          this.formSerializer
        );
      }
    }
    return a || o ? (r.setContentType("application/json", !1), Io(t)) : t;
  }],
  transformResponse: [function(t) {
    const r = this.transitional || Me.transitional, n = r && r.forcedJSONParsing, o = this.responseType === "json";
    if (t && l.isString(t) && (n && !this.responseType || o)) {
      const i = !(r && r.silentJSONParsing) && o;
      try {
        return JSON.parse(t);
      } catch (u) {
        if (i)
          throw u.name === "SyntaxError" ? P.from(u, P.ERR_BAD_RESPONSE, this, null, this.response) : u;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: q.classes.FormData,
    Blob: q.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }
};
l.forEach(["delete", "get", "head"], function(t) {
  Me.headers[t] = {};
});
l.forEach(["post", "put", "patch"], function(t) {
  Me.headers[t] = l.merge(Bo);
});
const bt = Me, Uo = l.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), zo = (e) => {
  const t = {};
  let r, n, o;
  return e && e.split(`
`).forEach(function(i) {
    o = i.indexOf(":"), r = i.substring(0, o).trim().toLowerCase(), n = i.substring(o + 1).trim(), !(!r || t[r] && Uo[r]) && (r === "set-cookie" ? t[r] ? t[r].push(n) : t[r] = [n] : t[r] = t[r] ? t[r] + ", " + n : n);
  }), t;
}, tr = Symbol("internals");
function ge(e) {
  return e && String(e).trim().toLowerCase();
}
function $e(e) {
  return e === !1 || e == null ? e : l.isArray(e) ? e.map($e) : String(e);
}
function Mo(e) {
  const t = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let n;
  for (; n = r.exec(e); )
    t[n[1]] = n[2];
  return t;
}
const Ho = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function rt(e, t, r, n, o) {
  if (l.isFunction(n))
    return n.call(this, t, r);
  if (o && (t = r), !!l.isString(t)) {
    if (l.isString(n))
      return t.indexOf(n) !== -1;
    if (l.isRegExp(n))
      return n.test(t);
  }
}
function Vo(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, r, n) => r.toUpperCase() + n);
}
function Wo(e, t) {
  const r = l.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(e, n + r, {
      value: function(o, a, i) {
        return this[n].call(this, t, o, a, i);
      },
      configurable: !0
    });
  });
}
let He = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, r, n) {
    const o = this;
    function a(u, f, c) {
      const h = ge(f);
      if (!h)
        throw new Error("header name must be a non-empty string");
      const g = l.findKey(o, h);
      (!g || o[g] === void 0 || c === !0 || c === void 0 && o[g] !== !1) && (o[g || f] = $e(u));
    }
    const i = (u, f) => l.forEach(u, (c, h) => a(c, h, f));
    return l.isPlainObject(t) || t instanceof this.constructor ? i(t, r) : l.isString(t) && (t = t.trim()) && !Ho(t) ? i(zo(t), r) : t != null && a(r, t, n), this;
  }
  get(t, r) {
    if (t = ge(t), t) {
      const n = l.findKey(this, t);
      if (n) {
        const o = this[n];
        if (!r)
          return o;
        if (r === !0)
          return Mo(o);
        if (l.isFunction(r))
          return r.call(this, o, n);
        if (l.isRegExp(r))
          return r.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, r) {
    if (t = ge(t), t) {
      const n = l.findKey(this, t);
      return !!(n && this[n] !== void 0 && (!r || rt(this, this[n], n, r)));
    }
    return !1;
  }
  delete(t, r) {
    const n = this;
    let o = !1;
    function a(i) {
      if (i = ge(i), i) {
        const u = l.findKey(n, i);
        u && (!r || rt(n, n[u], u, r)) && (delete n[u], o = !0);
      }
    }
    return l.isArray(t) ? t.forEach(a) : a(t), o;
  }
  clear(t) {
    const r = Object.keys(this);
    let n = r.length, o = !1;
    for (; n--; ) {
      const a = r[n];
      (!t || rt(this, this[a], a, t, !0)) && (delete this[a], o = !0);
    }
    return o;
  }
  normalize(t) {
    const r = this, n = {};
    return l.forEach(this, (o, a) => {
      const i = l.findKey(n, a);
      if (i) {
        r[i] = $e(o), delete r[a];
        return;
      }
      const u = t ? Vo(a) : String(a).trim();
      u !== a && delete r[a], r[u] = $e(o), n[u] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const r = /* @__PURE__ */ Object.create(null);
    return l.forEach(this, (n, o) => {
      n != null && n !== !1 && (r[o] = t && l.isArray(n) ? n.join(", ") : n);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, r]) => t + ": " + r).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...r) {
    const n = new this(t);
    return r.forEach((o) => n.set(o)), n;
  }
  static accessor(t) {
    const n = (this[tr] = this[tr] = {
      accessors: {}
    }).accessors, o = this.prototype;
    function a(i) {
      const u = ge(i);
      n[u] || (Wo(o, i), n[u] = !0);
    }
    return l.isArray(t) ? t.forEach(a) : a(t), this;
  }
};
He.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
l.freezeMethods(He.prototype);
l.freezeMethods(He);
const Z = He;
function nt(e, t) {
  const r = this || bt, n = t || r, o = Z.from(n.headers);
  let a = n.data;
  return l.forEach(e, function(u) {
    a = u.call(r, a, o.normalize(), t ? t.status : void 0);
  }), o.normalize(), a;
}
function Dr(e) {
  return !!(e && e.__CANCEL__);
}
function ve(e, t, r) {
  P.call(this, e ?? "canceled", P.ERR_CANCELED, t, r), this.name = "CanceledError";
}
l.inherits(ve, P, {
  __CANCEL__: !0
});
function qo(e, t, r) {
  const n = r.config.validateStatus;
  !r.status || !n || n(r.status) ? e(r) : t(new P(
    "Request failed with status code " + r.status,
    [P.ERR_BAD_REQUEST, P.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
const Jo = q.isStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  function() {
    return {
      write: function(r, n, o, a, i, u) {
        const f = [];
        f.push(r + "=" + encodeURIComponent(n)), l.isNumber(o) && f.push("expires=" + new Date(o).toGMTString()), l.isString(a) && f.push("path=" + a), l.isString(i) && f.push("domain=" + i), u === !0 && f.push("secure"), document.cookie = f.join("; ");
      },
      read: function(r) {
        const n = document.cookie.match(new RegExp("(^|;\\s*)(" + r + ")=([^;]*)"));
        return n ? decodeURIComponent(n[3]) : null;
      },
      remove: function(r) {
        this.write(r, "", Date.now() - 864e5);
      }
    };
  }()
) : (
  // Non standard browser env (web workers, react-native) lack needed support.
  function() {
    return {
      write: function() {
      },
      read: function() {
        return null;
      },
      remove: function() {
      }
    };
  }()
);
function Yo(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function Go(e, t) {
  return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function Br(e, t) {
  return e && !Yo(t) ? Go(e, t) : t;
}
const Ko = q.isStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const t = /(msie|trident)/i.test(navigator.userAgent), r = document.createElement("a");
    let n;
    function o(a) {
      let i = a;
      return t && (r.setAttribute("href", i), i = r.href), r.setAttribute("href", i), {
        href: r.href,
        protocol: r.protocol ? r.protocol.replace(/:$/, "") : "",
        host: r.host,
        search: r.search ? r.search.replace(/^\?/, "") : "",
        hash: r.hash ? r.hash.replace(/^#/, "") : "",
        hostname: r.hostname,
        port: r.port,
        pathname: r.pathname.charAt(0) === "/" ? r.pathname : "/" + r.pathname
      };
    }
    return n = o(window.location.href), function(i) {
      const u = l.isString(i) ? o(i) : i;
      return u.protocol === n.protocol && u.host === n.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  function() {
    return function() {
      return !0;
    };
  }()
);
function Xo(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function Zo(e, t) {
  e = e || 10;
  const r = new Array(e), n = new Array(e);
  let o = 0, a = 0, i;
  return t = t !== void 0 ? t : 1e3, function(f) {
    const c = Date.now(), h = n[a];
    i || (i = c), r[o] = f, n[o] = c;
    let g = a, v = 0;
    for (; g !== o; )
      v += r[g++], g = g % e;
    if (o = (o + 1) % e, o === a && (a = (a + 1) % e), c - i < t)
      return;
    const y = h && c - h;
    return y ? Math.round(v * 1e3 / y) : void 0;
  };
}
function rr(e, t) {
  let r = 0;
  const n = Zo(50, 250);
  return (o) => {
    const a = o.loaded, i = o.lengthComputable ? o.total : void 0, u = a - r, f = n(u), c = a <= i;
    r = a;
    const h = {
      loaded: a,
      total: i,
      progress: i ? a / i : void 0,
      bytes: u,
      rate: f || void 0,
      estimated: f && i && c ? (i - a) / f : void 0,
      event: o
    };
    h[t ? "download" : "upload"] = !0, e(h);
  };
}
const Qo = typeof XMLHttpRequest < "u", es = Qo && function(e) {
  return new Promise(function(r, n) {
    let o = e.data;
    const a = Z.from(e.headers).normalize(), i = e.responseType;
    let u;
    function f() {
      e.cancelToken && e.cancelToken.unsubscribe(u), e.signal && e.signal.removeEventListener("abort", u);
    }
    l.isFormData(o) && (q.isStandardBrowserEnv || q.isStandardBrowserWebWorkerEnv ? a.setContentType(!1) : a.setContentType("multipart/form-data;", !1));
    let c = new XMLHttpRequest();
    if (e.auth) {
      const y = e.auth.username || "", m = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
      a.set("Authorization", "Basic " + btoa(y + ":" + m));
    }
    const h = Br(e.baseURL, e.url);
    c.open(e.method.toUpperCase(), Nr(h, e.params, e.paramsSerializer), !0), c.timeout = e.timeout;
    function g() {
      if (!c)
        return;
      const y = Z.from(
        "getAllResponseHeaders" in c && c.getAllResponseHeaders()
      ), w = {
        data: !i || i === "text" || i === "json" ? c.responseText : c.response,
        status: c.status,
        statusText: c.statusText,
        headers: y,
        config: e,
        request: c
      };
      qo(function($) {
        r($), f();
      }, function($) {
        n($), f();
      }, w), c = null;
    }
    if ("onloadend" in c ? c.onloadend = g : c.onreadystatechange = function() {
      !c || c.readyState !== 4 || c.status === 0 && !(c.responseURL && c.responseURL.indexOf("file:") === 0) || setTimeout(g);
    }, c.onabort = function() {
      c && (n(new P("Request aborted", P.ECONNABORTED, e, c)), c = null);
    }, c.onerror = function() {
      n(new P("Network Error", P.ERR_NETWORK, e, c)), c = null;
    }, c.ontimeout = function() {
      let m = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded";
      const w = e.transitional || Lr;
      e.timeoutErrorMessage && (m = e.timeoutErrorMessage), n(new P(
        m,
        w.clarifyTimeoutError ? P.ETIMEDOUT : P.ECONNABORTED,
        e,
        c
      )), c = null;
    }, q.isStandardBrowserEnv) {
      const y = (e.withCredentials || Ko(h)) && e.xsrfCookieName && Jo.read(e.xsrfCookieName);
      y && a.set(e.xsrfHeaderName, y);
    }
    o === void 0 && a.setContentType(null), "setRequestHeader" in c && l.forEach(a.toJSON(), function(m, w) {
      c.setRequestHeader(w, m);
    }), l.isUndefined(e.withCredentials) || (c.withCredentials = !!e.withCredentials), i && i !== "json" && (c.responseType = e.responseType), typeof e.onDownloadProgress == "function" && c.addEventListener("progress", rr(e.onDownloadProgress, !0)), typeof e.onUploadProgress == "function" && c.upload && c.upload.addEventListener("progress", rr(e.onUploadProgress)), (e.cancelToken || e.signal) && (u = (y) => {
      c && (n(!y || y.type ? new ve(null, e, c) : y), c.abort(), c = null);
    }, e.cancelToken && e.cancelToken.subscribe(u), e.signal && (e.signal.aborted ? u() : e.signal.addEventListener("abort", u)));
    const v = Xo(h);
    if (v && q.protocols.indexOf(v) === -1) {
      n(new P("Unsupported protocol " + v + ":", P.ERR_BAD_REQUEST, e));
      return;
    }
    c.send(o || null);
  });
}, Fe = {
  http: To,
  xhr: es
};
l.forEach(Fe, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const ts = {
  getAdapter: (e) => {
    e = l.isArray(e) ? e : [e];
    const { length: t } = e;
    let r, n;
    for (let o = 0; o < t && (r = e[o], !(n = l.isString(r) ? Fe[r.toLowerCase()] : r)); o++)
      ;
    if (!n)
      throw n === !1 ? new P(
        `Adapter ${r} is not supported by the environment`,
        "ERR_NOT_SUPPORT"
      ) : new Error(
        l.hasOwnProp(Fe, r) ? `Adapter '${r}' is not available in the build` : `Unknown adapter '${r}'`
      );
    if (!l.isFunction(n))
      throw new TypeError("adapter is not a function");
    return n;
  },
  adapters: Fe
};
function ot(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new ve(null, e);
}
function nr(e) {
  return ot(e), e.headers = Z.from(e.headers), e.data = nt.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), ts.getAdapter(e.adapter || bt.adapter)(e).then(function(n) {
    return ot(e), n.data = nt.call(
      e,
      e.transformResponse,
      n
    ), n.headers = Z.from(n.headers), n;
  }, function(n) {
    return Dr(n) || (ot(e), n && n.response && (n.response.data = nt.call(
      e,
      e.transformResponse,
      n.response
    ), n.response.headers = Z.from(n.response.headers))), Promise.reject(n);
  });
}
const or = (e) => e instanceof Z ? e.toJSON() : e;
function ue(e, t) {
  t = t || {};
  const r = {};
  function n(c, h, g) {
    return l.isPlainObject(c) && l.isPlainObject(h) ? l.merge.call({ caseless: g }, c, h) : l.isPlainObject(h) ? l.merge({}, h) : l.isArray(h) ? h.slice() : h;
  }
  function o(c, h, g) {
    if (l.isUndefined(h)) {
      if (!l.isUndefined(c))
        return n(void 0, c, g);
    } else
      return n(c, h, g);
  }
  function a(c, h) {
    if (!l.isUndefined(h))
      return n(void 0, h);
  }
  function i(c, h) {
    if (l.isUndefined(h)) {
      if (!l.isUndefined(c))
        return n(void 0, c);
    } else
      return n(void 0, h);
  }
  function u(c, h, g) {
    if (g in t)
      return n(c, h);
    if (g in e)
      return n(void 0, c);
  }
  const f = {
    url: a,
    method: a,
    data: a,
    baseURL: i,
    transformRequest: i,
    transformResponse: i,
    paramsSerializer: i,
    timeout: i,
    timeoutMessage: i,
    withCredentials: i,
    adapter: i,
    responseType: i,
    xsrfCookieName: i,
    xsrfHeaderName: i,
    onUploadProgress: i,
    onDownloadProgress: i,
    decompress: i,
    maxContentLength: i,
    maxBodyLength: i,
    beforeRedirect: i,
    transport: i,
    httpAgent: i,
    httpsAgent: i,
    cancelToken: i,
    socketPath: i,
    responseEncoding: i,
    validateStatus: u,
    headers: (c, h) => o(or(c), or(h), !0)
  };
  return l.forEach(Object.keys(Object.assign({}, e, t)), function(h) {
    const g = f[h] || o, v = g(e[h], t[h], h);
    l.isUndefined(v) && g !== u || (r[h] = v);
  }), r;
}
const Ir = "1.4.0", yt = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  yt[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const sr = {};
yt.transitional = function(t, r, n) {
  function o(a, i) {
    return "[Axios v" + Ir + "] Transitional option '" + a + "'" + i + (n ? ". " + n : "");
  }
  return (a, i, u) => {
    if (t === !1)
      throw new P(
        o(i, " has been removed" + (r ? " in " + r : "")),
        P.ERR_DEPRECATED
      );
    return r && !sr[i] && (sr[i] = !0, console.warn(
      o(
        i,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), t ? t(a, i, u) : !0;
  };
};
function rs(e, t, r) {
  if (typeof e != "object")
    throw new P("options must be an object", P.ERR_BAD_OPTION_VALUE);
  const n = Object.keys(e);
  let o = n.length;
  for (; o-- > 0; ) {
    const a = n[o], i = t[a];
    if (i) {
      const u = e[a], f = u === void 0 || i(u, a, e);
      if (f !== !0)
        throw new P("option " + a + " must be " + f, P.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new P("Unknown option " + a, P.ERR_BAD_OPTION);
  }
}
const lt = {
  assertOptions: rs,
  validators: yt
}, ne = lt.validators;
let De = class {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new er(),
      response: new er()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(t, r) {
    typeof t == "string" ? (r = r || {}, r.url = t) : r = t || {}, r = ue(this.defaults, r);
    const { transitional: n, paramsSerializer: o, headers: a } = r;
    n !== void 0 && lt.assertOptions(n, {
      silentJSONParsing: ne.transitional(ne.boolean),
      forcedJSONParsing: ne.transitional(ne.boolean),
      clarifyTimeoutError: ne.transitional(ne.boolean)
    }, !1), o != null && (l.isFunction(o) ? r.paramsSerializer = {
      serialize: o
    } : lt.assertOptions(o, {
      encode: ne.function,
      serialize: ne.function
    }, !0)), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let i;
    i = a && l.merge(
      a.common,
      a[r.method]
    ), i && l.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (m) => {
        delete a[m];
      }
    ), r.headers = Z.concat(i, a);
    const u = [];
    let f = !0;
    this.interceptors.request.forEach(function(w) {
      typeof w.runWhen == "function" && w.runWhen(r) === !1 || (f = f && w.synchronous, u.unshift(w.fulfilled, w.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(w) {
      c.push(w.fulfilled, w.rejected);
    });
    let h, g = 0, v;
    if (!f) {
      const m = [nr.bind(this), void 0];
      for (m.unshift.apply(m, u), m.push.apply(m, c), v = m.length, h = Promise.resolve(r); g < v; )
        h = h.then(m[g++], m[g++]);
      return h;
    }
    v = u.length;
    let y = r;
    for (g = 0; g < v; ) {
      const m = u[g++], w = u[g++];
      try {
        y = m(y);
      } catch (A) {
        w.call(this, A);
        break;
      }
    }
    try {
      h = nr.call(this, y);
    } catch (m) {
      return Promise.reject(m);
    }
    for (g = 0, v = c.length; g < v; )
      h = h.then(c[g++], c[g++]);
    return h;
  }
  getUri(t) {
    t = ue(this.defaults, t);
    const r = Br(t.baseURL, t.url);
    return Nr(r, t.params, t.paramsSerializer);
  }
};
l.forEach(["delete", "get", "head", "options"], function(t) {
  De.prototype[t] = function(r, n) {
    return this.request(ue(n || {}, {
      method: t,
      url: r,
      data: (n || {}).data
    }));
  };
});
l.forEach(["post", "put", "patch"], function(t) {
  function r(n) {
    return function(a, i, u) {
      return this.request(ue(u || {}, {
        method: t,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: a,
        data: i
      }));
    };
  }
  De.prototype[t] = r(), De.prototype[t + "Form"] = r(!0);
});
const Ne = De;
let ns = class Ur {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(a) {
      r = a;
    });
    const n = this;
    this.promise.then((o) => {
      if (!n._listeners)
        return;
      let a = n._listeners.length;
      for (; a-- > 0; )
        n._listeners[a](o);
      n._listeners = null;
    }), this.promise.then = (o) => {
      let a;
      const i = new Promise((u) => {
        n.subscribe(u), a = u;
      }).then(o);
      return i.cancel = function() {
        n.unsubscribe(a);
      }, i;
    }, t(function(a, i, u) {
      n.reason || (n.reason = new ve(a, i, u), r(n.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(t);
    r !== -1 && this._listeners.splice(r, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new Ur(function(o) {
        t = o;
      }),
      cancel: t
    };
  }
};
const os = ns;
function ss(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function as(e) {
  return l.isObject(e) && e.isAxiosError === !0;
}
const ct = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(ct).forEach(([e, t]) => {
  ct[t] = e;
});
const is = ct;
function zr(e) {
  const t = new Ne(e), r = vr(Ne.prototype.request, t);
  return l.extend(r, Ne.prototype, t, { allOwnKeys: !0 }), l.extend(r, t, null, { allOwnKeys: !0 }), r.create = function(o) {
    return zr(ue(e, o));
  }, r;
}
const L = zr(bt);
L.Axios = Ne;
L.CanceledError = ve;
L.CancelToken = os;
L.isCancel = Dr;
L.VERSION = Ir;
L.toFormData = ze;
L.AxiosError = P;
L.Cancel = L.CanceledError;
L.all = function(t) {
  return Promise.all(t);
};
L.spread = ss;
L.isAxiosError = as;
L.mergeConfig = ue;
L.AxiosHeaders = Z;
L.formToJSON = (e) => jr(l.isHTMLForm(e) ? new FormData(e) : e);
L.HttpStatusCode = is;
L.default = L;
const ls = L, {
  Axios: aa,
  AxiosError: cs,
  CanceledError: ia,
  isCancel: la,
  CancelToken: ca,
  VERSION: ua,
  all: da,
  Cancel: fa,
  isAxiosError: ha,
  spread: pa,
  toFormData: ma,
  AxiosHeaders: ga,
  HttpStatusCode: ba,
  formToJSON: ya,
  mergeConfig: wa
} = ls;
var Mr = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, ar = X.createContext && X.createContext(Mr), oe = globalThis && globalThis.__assign || function() {
  return oe = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, oe.apply(this, arguments);
}, us = globalThis && globalThis.__rest || function(e, t) {
  var r = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
};
function Hr(e) {
  return e && e.map(function(t, r) {
    return X.createElement(t.tag, oe({
      key: r
    }, t.attr), Hr(t.child));
  });
}
function wt(e) {
  return function(t) {
    return X.createElement(ds, oe({
      attr: oe({}, e.attr)
    }, t), Hr(e.child));
  };
}
function ds(e) {
  var t = function(r) {
    var n = e.attr, o = e.size, a = e.title, i = us(e, ["attr", "size", "title"]), u = o || r.size || "1em", f;
    return r.className && (f = r.className), e.className && (f = (f ? f + " " : "") + e.className), X.createElement("svg", oe({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, r.attr, n, i, {
      className: f,
      style: oe(oe({
        color: e.color || r.color
      }, r.style), e.style),
      height: u,
      width: u,
      xmlns: "http://www.w3.org/2000/svg"
    }), a && X.createElement("title", null, a), e.children);
  };
  return ar !== void 0 ? X.createElement(ar.Consumer, null, function(r) {
    return t(r);
  }) : t(Mr);
}
function fs(e) {
  return wt({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M12 19a6.995 6.995 0 0110-6.32V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h8.08c-.05-.33-.08-.66-.08-1zM4 6l8 5 8-5v2l-8 5-8-5V6zm13.34 16l-3.54-3.54 1.41-1.41 2.12 2.12 4.24-4.24L23 16.34 17.34 22z" } }] })(e);
}
function Vr(e) {
  return wt({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0z" } }, { tag: "path", attr: { d: "M12 6a9.77 9.77 0 018.82 5.5 9.647 9.647 0 01-2.41 3.12l1.41 1.41c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l1.65 1.65C10.66 6.09 11.32 6 12 6zm-1.07 1.14L13 9.21c.57.25 1.03.71 1.28 1.28l2.07 2.07c.08-.34.14-.7.14-1.07C16.5 9.01 14.48 7 12 7c-.37 0-.72.05-1.07.14zM2.01 3.87l2.68 2.68A11.738 11.738 0 001 11.5C2.73 15.89 7 19 12 19c1.52 0 2.98-.29 4.32-.82l3.42 3.42 1.41-1.41L3.42 2.45 2.01 3.87zm7.5 7.5l2.61 2.61c-.04.01-.08.02-.12.02a2.5 2.5 0 01-2.5-2.5c0-.05.01-.08.01-.13zm-3.4-3.4l1.75 1.75a4.6 4.6 0 00-.36 1.78 4.507 4.507 0 006.27 4.14l.98.98c-.88.24-1.8.38-2.75.38a9.77 9.77 0 01-8.82-5.5c.7-1.43 1.72-2.61 2.93-3.53z" } }] })(e);
}
function Wr(e) {
  return wt({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0V0z" } }, { tag: "path", attr: { d: "M12 6a9.77 9.77 0 018.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5A9.77 9.77 0 0112 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5a2.5 2.5 0 010 5 2.5 2.5 0 010-5m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z" } }] })(e);
}
const hs = x.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`, ir = x.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  font-size: 0.875rem;
  padding: 0 0 0.5rem;
`, lr = x.h1`
  font-size: 1.5rem;
  margin: 1.5rem auto;
`, ps = x.p`
  font-size: 0.875rem;
  text-align: center;
`, ms = x.form`
  display: flex;
  flex-direction: column;
`, Le = x.label`
  background-color: ${b.white300};
  color: ${b.labelText};
  font-size: 0.875rem;
  left: 16px;
  max-width: 90%;
  overflow: hidden;
  padding: 1px 6px;
  position: absolute;
  text-overflow: ellipsis;
  top: 50%;
  transform-origin: 0;
  transform: translateY(-50%);
  transition: transform 0.15s ease-in-out, top 0.15s ease-in-out,
    padding 0.15s ease-in-out;
  user-select: none;
  white-space: nowrap;
  z-index: 1;
`, gs = x.fieldset`
  all: unset;
  align-items: center;
  background-color: ${b.white300};
  border-radius: ${z.lg};
  border: 1px solid ${b.authPagesFieldBorder};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 0.75rem;
  position: relative;
  transition: box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out;

  &:focus-within {
    border: 1px solid ${b.authPagesFieldBorder};

    & ${Le} {
      color: ${b.fieldFocus};
      top: -2px;
      transform: scale(0.88) translateX(-0.5rem) translateY(-50%);
      white-space: normal;
    }
  }

  ${({ filled: e = !1, isInvalid: t = !1 }) => e && (t ? se`
          border: 1px solid ${b.red300};

          & ${Le} {
            color: ${b.red300};
            top: -2px;
            transform: scale(0.88) translateX(-0.5rem) translateY(-50%);
            white-space: normal;
          }
        ` : se`
          border: 1px solid ${b.fieldFocus};

          & ${Le} {
            color: ${b.fieldFocus};
            top: -2px;
            transform: scale(0.88) translateX(-0.5rem) translateY(-50%);
            white-space: normal;
          }
        `)}
`, bs = x.input`
  -webkit-appearance: none;
  background-color: none;
  border-radius: ${z.lg};
  border: none;
  color: ${b.text};
  flex-grow: 1;
  font-size: 1rem;
  height: 2.5rem;
  line-height: 1.1;
  outline: none;
  padding: 0 1rem;
  transition: box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out;
`, ys = x.div`
  all: unset;
  align-items: center;
  border-radius: 50%;
  border: 3px solid ${b.button};
  color: ${b.button};
  display: inline-flex;
  font-size: 1rem;
  height: 3.5rem;
  justify-content: center;
  width: 3.5rem;
  margin-bottom: 1.5rem;
`, ws = x(fs)`
  height: 2rem;
  width: 2rem;
`, Es = x.p`
  font-size: 0.875rem;
  color: ${b.red300};
`, xs = x.button`
  all: unset;
  cursor: pointer;
  align-items: center;
  border-radius: ${z.sm};
  color: ${b.white300};
  display: flex;
  font-size: 1rem;
  height: 3.25rem;
  justify-content: center;
  margin-top: 1.5rem;
  width: 100%;
  background-color: ${b.button};

  &:hover {
    opacity: 0.9;
  }
`, vs = x(dt)`
  all: unset;
  align-items: center;
  background-color: ${b.blue400};
  border-radius: ${z.lg};
  color: ${b.white300};
  display: flex;
  font-size: 1rem;
  height: 2.5rem;
  justify-content: center;
  margin-top: 1.5rem;

  &:hover {
    opacity: 0.9;
  }
`, Rs = x.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: 5rem;
`, Ss = x(hr)`
  align-items: center;
  color: ${b.fieldFocus};
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.5;
  padding: 0.25rem;
  text-decoration: none;
`, Ts = x(pr)`
  max-height: 6.875rem;
`, Ea = ({
  authorizationRoute: e
}) => {
  const [t, r] = U(""), [n, o] = U(!1), [a, i] = U(""), [u, f] = U(!1), c = !n, { forgotPassword: h } = Ee();
  return /* @__PURE__ */ R(pt, { dataCy: "forgot-password-form-container", children: c ? /* @__PURE__ */ D(ht, { children: [
    /* @__PURE__ */ D(ir, { "data-cy": "text-container", children: [
      /* @__PURE__ */ R(
        Ts,
        {
          src: "/logo.png",
          alt: "logo-image",
          dataCy: "logo-image"
        }
      ),
      /* @__PURE__ */ R(lr, { "data-cy": "title-recoverPassword", children: "Recover your password" })
    ] }),
    /* @__PURE__ */ D(ms, { onSubmit: (v) => {
      v.preventDefault(), v.stopPropagation(), !u && (f(!0), i(""), h({
        email: t
      }).then(() => {
        o(!0);
      }).catch((y) => {
        if (!(y instanceof cs)) {
          i("Unexpected error, please try again later");
          return;
        }
        const { response: m } = y;
        if (!m) {
          i("Unexpected error, please try again later");
          return;
        }
        const { status: w, data: A } = m;
        w >= 500 ? i("Server error, please try again later") : i(A.error.message);
      }).finally(() => {
        f(!1);
      }));
    }, "data-cy": "forgot-password-form", children: [
      /* @__PURE__ */ D(gs, { filled: !!t, children: [
        /* @__PURE__ */ R(
          bs,
          {
            "data-cy": "input-email",
            defaultValue: t,
            id: "email",
            onChange: (v) => {
              r(v.target.value);
            },
            required: !0,
            type: "email",
            maxLength: 40
          }
        ),
        /* @__PURE__ */ R(Le, { "data-cy": "label-email", htmlFor: "email", children: "Email address" })
      ] }),
      /* @__PURE__ */ R(Es, { "data-cy": a, children: a }),
      /* @__PURE__ */ R(
        vs,
        {
          type: "submit",
          "data-cy": "button-recoverPassword",
          loading: u,
          children: "Recover password"
        }
      )
    ] }),
    /* @__PURE__ */ D(Rs, { "data-cy": "text-goBack", children: [
      "Go back to",
      /* @__PURE__ */ R(
        Ss,
        {
          to: je(e),
          "data-cy": "button-login",
          children: "Login"
        }
      )
    ] })
  ] }) : /* @__PURE__ */ D(hs, { "data-cy": "success-content", children: [
    /* @__PURE__ */ D(ir, { "data-cy": "text-container", children: [
      /* @__PURE__ */ R(lr, { "data-cy": "title-checkInbox", children: "Check your inbox!" }),
      /* @__PURE__ */ R(ys, { "data-cy": "imagem-container", children: /* @__PURE__ */ R(ws, {}) }),
      /* @__PURE__ */ R(ps, { "data-cy": "description-checkEmail", children: `Please check your email ${t} for instructions on how you can reset your password.` })
    ] }),
    /* @__PURE__ */ R(
      xs,
      {
        "data-cy": "button-resendEmail",
        onClick: () => {
          o(!1);
        },
        children: "Resend email"
      }
    )
  ] }) });
}, Os = x.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  font-size: 0.875rem;
  padding: 0 0 0.5rem;
`, Ps = x.h1`
  font-size: 1.5rem;
  margin: 1.5rem auto;
`;
x.p`
  font-size: 0.875rem;
  text-align: center;
`;
const Cs = x.form`
  display: flex;
  flex-direction: column;
`, be = x.label`
  background-color: ${b.white300};
  color: ${b.labelText};
  font-size: 0.875rem;
  left: 16px;
  max-width: 90%;
  overflow: hidden;
  padding: 1px 6px;
  position: absolute;
  text-overflow: ellipsis;
  top: 50%;
  transform-origin: 0;
  transform: translateY(-50%);
  transition: transform 0.15s ease-in-out, top 0.15s ease-in-out,
    padding 0.15s ease-in-out;
  user-select: none;
  white-space: nowrap;
  z-index: 1;
`, cr = x.fieldset`
  all: unset;
  align-items: center;
  background-color: ${b.white300};
  border-radius: ${z.lg};
  border: 1px solid ${b.authPagesFieldBorder};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 0.75rem;
  position: relative;
  transition: box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out;

  &:focus-within {
    border: 1px solid ${b.authPagesFieldBorder};

    & ${be} {
      color: ${b.fieldFocus};
      top: -2px;
      transform: scale(0.88) translateX(-0.5rem) translateY(-50%);
      white-space: normal;
    }
  }

  ${({ filled: e = !1, isInvalid: t = !1 }) => e && (t ? se`
          border: 1px solid ${b.red300};

          & ${be} {
            color: ${b.red300};
            top: -2px;
            transform: scale(0.88) translateX(-0.5rem) translateY(-50%);
            white-space: normal;
          }
        ` : se`
          border: 1px solid ${b.fieldFocus};

          & ${be} {
            color: ${b.fieldFocus};
            top: -2px;
            transform: scale(0.88) translateX(-0.5rem) translateY(-50%);
            white-space: normal;
          }
        `)}
`, ur = x.input`
  -webkit-appearance: none;
  background-color: none;
  border-radius: ${z.lg};
  border: none;
  color: ${b.text};
  flex-grow: 1;
  font-size: 1rem;
  height: 2.5rem;
  line-height: 1.1;
  outline: none;
  padding: 0 1rem;
  transition: box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out;
`, _s = x.p`
  font-size: 0.875rem;
  color: ${b.red300};
`, As = x.button`
  all: unset;
  align-items: center;
  border-radius: ${z.px};
  color: ${b.labelText};
  display: inline-flex;
  font-size: 1rem;
  height: 2.5rem;
  justify-content: center;
  width: 2.75rem;

  &:hover {
    background-color: ${b.backgroundHover};
  }
`, ks = x(Wr)``, $s = x(Vr)``, Fs = x(hr)`
  align-items: center;
  border-radius: ${z.px};
  color: ${b.authPagesLink};
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.5;
  padding: 4px;
  text-decoration: none;
`, Ns = x(dt)`
  all: unset;
  align-items: center;
  background-color: ${b.blue400};
  border-radius: ${z.lg};
  color: ${b.white300};
  display: flex;
  font-size: 1rem;
  height: 2.5rem;
  justify-content: center;
  margin-top: 1.5rem;

  &:hover {
    opacity: 0.9;
  }
`, Ls = x(pr)`
  max-height: 6.875rem;
`, xa = () => {
  const [e, t] = U(""), [r, n] = U(""), [o, a] = U({}), [i, u] = U(!1), [f, c] = U(!1), { signIn: h } = Ee(), g = () => {
    u((y) => !y);
  };
  return /* @__PURE__ */ D(pt, { dataCy: "login-form-container", children: [
    /* @__PURE__ */ D(Os, { "data-cy": "text-container", children: [
      /* @__PURE__ */ R(
        Ls,
        {
          src: "/logo.png",
          alt: "logo-image",
          dataCy: "image-logo"
        }
      ),
      /* @__PURE__ */ R(Ps, { "data-cy": "text-title", children: "Login on your account" })
    ] }),
    /* @__PURE__ */ D(Cs, { onSubmit: (y) => {
      if (y.preventDefault(), r && !gr.test(r)) {
        a({
          password: "Password must contain at least 8 characters, 1 lowercase letter, 1 uppercase letter, 1 number, and 1 special character"
        });
        return;
      }
      if (f)
        return;
      c(!0), a({}), h({
        email: e,
        password: r
      }).catch(({ response: w }) => {
        if (!w) {
          a({
            other: "Unexpected error, please try again later"
          });
          return;
        }
        w.data.error.code >= 500 ? a({
          other: "Server error, please try again later"
        }) : a({
          other: w.data.error.message
        });
      }).finally(() => {
        c(!1);
      });
    }, "data-cy": "login-form", children: [
      /* @__PURE__ */ D(cr, { filled: !!e, children: [
        /* @__PURE__ */ R(
          ur,
          {
            "data-cy": "input-email",
            defaultValue: e,
            id: "email",
            onChange: (y) => {
              t(y.target.value);
            },
            required: !0,
            type: "email",
            maxLength: 40
          }
        ),
        /* @__PURE__ */ R(be, { "data-cy": "label-email", htmlFor: "email", children: "Email address" })
      ] }),
      /* @__PURE__ */ D(cr, { filled: !!r, isInvalid: !!o.password, children: [
        /* @__PURE__ */ R(
          ur,
          {
            "data-cy": "input-password",
            defaultValue: r,
            id: "password",
            onChange: (y) => {
              n(y.target.value);
            },
            required: !0,
            type: i ? "text" : "password",
            maxLength: 20
          }
        ),
        /* @__PURE__ */ R(be, { "data-cy": "label-password", htmlFor: "password", children: "Password" }),
        /* @__PURE__ */ R(
          As,
          {
            "data-cy": "button-eye",
            onClick: g,
            type: "button",
            children: i ? /* @__PURE__ */ R(ks, { "data-cy": "icon-locked" }) : /* @__PURE__ */ R($s, { "data-cy": "icon-unlocked" })
          }
        )
      ] }),
      /* @__PURE__ */ R(_s, { "data-cy": o.password ?? o.other, children: o.password ?? o.other }),
      /* @__PURE__ */ R(Fs, { to: "/forgot-password", "data-cy": "button-forgotPassword", children: "Forgot password?" }),
      /* @__PURE__ */ R(Ns, { type: "submit", "data-cy": "button-login", loading: f, children: "Log In" })
    ] })
  ] });
}, js = x.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  font-size: 0.875rem;
  padding: 0 0 1.5rem;
`, Ds = x.h1`
  font-size: 1.5rem;
  margin-bottom: 0.875rem;
`, Bs = x.p`
  font-size: 0.875rem;
  text-align: center;
`, Is = x.form`
  display: flex;
  flex-direction: column;
`, ye = x.label`
  background-color: ${b.white300};
  color: ${b.labelText};
  font-size: 0.875rem;
  left: 16px;
  max-width: 90%;
  overflow: hidden;
  padding: 1px 6px;
  position: absolute;
  text-overflow: ellipsis;
  top: 50%;
  transform-origin: 0;
  transform: translateY(-50%);
  transition: transform 0.15s ease-in-out, top 0.15s ease-in-out,
    padding 0.15s ease-in-out;
  user-select: none;
  white-space: nowrap;
  z-index: 1;
`, dr = x.fieldset`
  all: unset;
  align-items: center;
  background-color: ${b.white300};
  border-radius: ${z.lg};
  border: 1px solid ${b.authPagesFieldBorder};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 0.75rem;
  position: relative;
  transition: box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out;

  &:focus-within {
    border: 1px solid ${b.authPagesFieldBorder};

    & ${ye} {
      color: ${b.fieldFocus};
      top: -2px;
      transform: scale(0.88) translateX(-0.5rem) translateY(-50%);
      white-space: normal;
    }
  }

  ${({ filled: e = !1, isInvalid: t = !1 }) => e && (t ? se`
          border: 1px solid ${b.red300};

          & ${ye} {
            color: ${b.red300};
            top: -2px;
            transform: scale(0.88) translateX(-0.5rem) translateY(-50%);
            white-space: normal;
          }
        ` : se`
          border: 1px solid ${b.fieldFocus};

          & ${ye} {
            color: ${b.fieldFocus};
            top: -2px;
            transform: scale(0.88) translateX(-0.5rem) translateY(-50%);
            white-space: normal;
          }
        `)}
`, fr = x.input`
  -webkit-appearance: none;
  background-color: none;
  border-radius: ${z.lg};
  border: none;
  color: ${b.text};
  flex-grow: 1;
  font-size: 1rem;
  height: 2.5rem;
  line-height: 1.1;
  outline: none;
  padding: 0 1rem;
  transition: box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out;
`, Us = x.p`
  font-size: 0.875rem;
  color: ${b.red300};
`, zs = x.button`
  all: unset;
  align-items: center;
  border-radius: ${z.px};
  color: ${b.labelText};
  display: inline-flex;
  font-size: 1rem;
  height: 2.5rem;
  justify-content: center;
  width: 2.75rem;

  &:hover {
    background-color: ${b.backgroundHover};
  }
`, Ms = x(Wr)``, Hs = x(Vr)``, Vs = x(dt)`
  all: unset;
  align-items: center;
  background-color: ${b.blue400};
  border-radius: ${z.lg};
  color: ${b.white300};
  display: flex;
  font-size: 1rem;
  height: 2.5rem;
  justify-content: center;
  margin-top: 1.5rem;

  &:hover {
    opacity: 0.9;
  }
`, va = () => {
  const [e, t] = U(""), [r, n] = U(""), [o, a] = U({}), [i, u] = U(!1), [f, c] = U(!1), h = Pn(), g = new URLSearchParams(h.search), { resetPassword: v, signIn: y } = Ee(), m = () => {
    u((A) => !A);
  }, w = (A) => {
    if (A.preventDefault(), r && !gr.test(r)) {
      a({
        password: "Password must contain at least 8 characters, 1 lowercase letter, 1 uppercase letter, 1 number, and 1 special character and no whitespace."
      });
      return;
    }
    f || (c(!0), a({}), v({
      email: e,
      password: r
    }).then(() => {
      y({ email: e, password: r }).finally(() => {
        c(!1);
      });
    }).catch(($) => {
      if (!$.isAxiosError) {
        a({
          other: "Unexpected error, please try again later"
        });
        return;
      }
      const { response: _ } = $;
      if (!_) {
        a({
          other: "Unexpected error, please try again later"
        });
        return;
      }
      const { status: V, data: Q } = _;
      V >= 500 && a({
        other: "Server error, please try again later"
      }), Q.error.message && a({
        other: Q.error.message ?? "Wrong email or password, please check your answer"
      });
    }).finally(() => {
      c(!1);
    }));
  };
  return ut(() => {
    const A = g.get("email") ?? "";
    t(A);
  }, []), /* @__PURE__ */ D(pt, { dataCy: "reset-password-content-modal", children: [
    /* @__PURE__ */ D(js, { "data-cy": "text-container", children: [
      /* @__PURE__ */ R(Ds, { "data-cy": "title-resetPassword", children: "Reset Password" }),
      /* @__PURE__ */ R(Bs, { "data-cy": "text-descriptionResetPassword", children: "Enter your email and a new password to reset your password account." })
    ] }),
    /* @__PURE__ */ D(Is, { onSubmit: w, "data-cy": "reset-password-form", children: [
      /* @__PURE__ */ D(dr, { filled: !!e, children: [
        /* @__PURE__ */ R(
          fr,
          {
            "data-cy": "input-email",
            defaultValue: e,
            id: "email",
            required: !0,
            type: "email",
            maxLength: 40,
            disabled: !0
          }
        ),
        /* @__PURE__ */ R(ye, { "data-cy": "label-email", htmlFor: "email", children: "Email" })
      ] }),
      /* @__PURE__ */ D(dr, { filled: !!r, isInvalid: !!o.password, children: [
        /* @__PURE__ */ R(
          fr,
          {
            "data-cy": "input-password",
            defaultValue: r,
            id: "password",
            onChange: (A) => {
              n(A.target.value);
            },
            required: !0,
            type: i ? "text" : "password",
            maxLength: 20
          }
        ),
        /* @__PURE__ */ R(ye, { "data-cy": "label-password", htmlFor: "password", children: "Password" }),
        /* @__PURE__ */ R(
          zs,
          {
            "data-cy": "buttonEye",
            onClick: m,
            type: "button",
            children: i ? /* @__PURE__ */ R(Ms, { "data-cy": "icon-locked" }) : /* @__PURE__ */ R(Hs, { "data-cy": "icon-unlocked" })
          }
        )
      ] }),
      /* @__PURE__ */ R(Us, { "data-cy": o.password ?? o.other, children: o.password ?? o.other }),
      /* @__PURE__ */ R(
        Vs,
        {
          type: "submit",
          "data-cy": "button-resetPassword",
          loading: f,
          children: "Reset Password"
        }
      )
    ] })
  ] });
}, Ra = () => {
  const { saveUser: e } = Ee();
  return ut(() => {
    const t = new URLSearchParams(window.location.search), r = t.get("token") ?? "", n = t.get("firstName") ?? "", o = t.get("lastName") ?? "", a = t.get("email") ?? "", i = (t.get("roles") ?? "").split(","), u = Number(t.get("companyId")), f = Number(t.get("id")), c = {
      firstName: n,
      lastName: o,
      email: a,
      roles: i,
      companyId: u,
      id: f,
      status: "active",
      job: ""
    };
    r !== "" && (localStorage.setItem("JWT_TOKEN", r), e(c));
  }, []), null;
};
export {
  wr as AuthContext,
  ta as AuthProvider,
  br as AuthService,
  Ae as AuthStorageKey,
  ra as Can,
  Ea as ForgotPassword,
  pt as FormLayout,
  xa as Login,
  Ra as PermissionRedirect,
  na as PrivateRoute,
  va as ResetPassword,
  ce as authBroadcastChannelEvents,
  mr as authBroadcastChannelName,
  Ks as broadcastSignOut,
  ea as handlerRejection,
  Qs as handlerRequest,
  Xs as notifyForbidden,
  Zs as refreshToken,
  gr as strongPasswordValidRegex,
  Ee as useAuth,
  Er as useCan,
  jn as validateUserPermissions
};
